import { Component } from '@angular/core';
import { UscMobileActionPlansComponent } from '../usc-mobile-action-plans/usc-mobile-action-plans.component';

@Component({
    selector: 'sn-usc-prev-month-action-plans',
    templateUrl: '../usc-table-view/usc-table-view.component.html',
    styleUrls: ['../usc-mobile-action-plans/usc-mobile-action-plans.component.css', '../usc-table-view/usc-table-view.component.css']
})

export class UscPrevMonthActionPlansComponent extends UscMobileActionPlansComponent {

    ngOnInit() {
        this.view = this.uscStoreService.view_p2w_previous_action_plans;
        this.is_current_month = false;

        super.ngOnInit();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-prev-month-action-plans/usc-prev-month-action-plans.component.ts